import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from "@angular/core";
import { BaseChartDirective } from "ng2-charts";
import { Router, RouterModule } from "@angular/router";
import { APIURL } from "app/Shared/Constant/API_Urls";
import { HttpErrorResponse } from "@angular/common/http";
import { UrlsService } from "app/Shared/Services/urls.service";
import { UserService } from "app/Shared/Services/user.service";
import { SharedHttpClientService } from "app/Shared/Services/shared-http-client.service";
import { EmitterService } from "app/Shared/Services/emitter.service";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { map, Subscription } from "rxjs";
import { ChartConfiguration } from 'chart.js';
import { MatTable, MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import {MatCardModule} from '@angular/material/card';
import { MatTooltipModule } from "@angular/material/tooltip";
import { DatePipe, CommonModule, TitleCasePipe } from "@angular/common";

@Component({
    selector: 'app-cat-pre-submission-details',
    imports: [RouterModule, MatTable, MatSortModule, MatPaginatorModule, MatTableModule, MatCardModule,
        MatTooltipModule, MatProgressSpinnerModule, BaseChartDirective, DatePipe, CommonModule, TitleCasePipe, BaseChartDirective
    ],
    templateUrl: './cat-pre-submission-details.component.html',
    styleUrls: ['./cat-pre-submission-details.component.scss']
})
export class CatPreValidationDetailsComponent implements OnInit, AfterViewInit, OnDestroy {
  JsonData!: Object;
  Totalcount!: number;
  todate: Date = new Date();
  @ViewChild(BaseChartDirective)
  chart!: BaseChartDirective;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  isLoadingResults!: boolean;
  isRateLimitReached = false;
  displayedColumns = ["Reject_Code", "Rejects"];
  dataset: any = [];
  LastCATExecutionDate:any;
  Label = "CATException";
  totalExceptions = 0;
  dataSource = new MatTableDataSource();
  public redirectUrl: any = "true";
  rowcount: number = 50;
  public subscription!: Subscription;
  public pieChartOptions: any = {
    responsive: true,
    
    plugins: {
      datalabels: {
        display: false
      },
      legend: {
        position: 'bottom',
      },
    }
  };
  public pieChartLabels: any[] = ["No Data"];
  public pieChartData: any[] = [];
  public pieChartType: any = 'pie';
  public pieChartLegend = true;
  //  public pieChartPlugins = [pluginDataLabels];
  public pieChartColors = [
    {
      backgroundColor: ['rgba(255,0,0,0.3)', 'rgba(0,255,0,0.3)', 'rgba(0,0,255,0.3)', 'rgba(0,245,255,10.3)', 'rgba(5,0,255,0.3)'],
    },
  ];
  public chartData: ChartConfiguration<'pie'>['data'] = {
    labels: this.pieChartLabels,
    datasets: [{data: this.pieChartData,
      backgroundColor: ['rgba(255,0,0,0.3)', 'rgba(0,255,0,0.3)', 'rgba(0,0,255,0.3)', 'rgba(0,245,255,10.3)', 'rgba(5,0,255,0.3)'],
    }]
  }

  constructor(
    private router: Router,
    private UrlsService: UrlsService,
    public UserService: UserService,
    private SharedHttpClientService: SharedHttpClientService,
    private EmitterService: EmitterService,
    public date:DatePipe) {
    this.LastCATExecutionDate = null;
  }
  ngOnInit() {
    /*** Get Last CAT Execution date*/
    this.LastCATExecutionDate = this.UserService.getyyyyMMddDateFormate(this.UserService.CATDashboard_LastExecutionDate);
    if (this.LastCATExecutionDate) {
      this.getPreValidationCount(this.Label, this.LastCATExecutionDate)
      this.subscription = this.EmitterService.getOpenExceptionCount.subscribe(getOpenExceptionCount => {
        this.Label = getOpenExceptionCount.Label;
        this.LastCATExecutionDate = getOpenExceptionCount.Date;
        //alert(this.Label)
        this.getPreValidationCount(getOpenExceptionCount.Label, getOpenExceptionCount.Date)
      });
      this.subscription = this.EmitterService.reloadMainDashBoard.subscribe(value => {
        if (value) {
          this.isLoadingResults = true;
          this.UserService.get_CAT_Last_ReportDate().subscribe((res: any) => {
            let response: any = res;
            let jsondata = response.data[0]
            if(jsondata) {
              this.LastCATExecutionDate = jsondata.CATLastExcecutionReportDate !=="" ? this.UserService.getFormatedDate(jsondata.CATLastExcecutionReportDate) : new Date();
              this.LastCATExecutionDate = this.UserService.getyyyyMMddDateFormate(this.LastCATExecutionDate);
              this.getPreValidationCount('CAT', this.LastCATExecutionDate);
            }
          });
        }
      });
    }
  }
  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }
  setMenu(code: any) {
    this.EmitterService.setActiveMenu.emit({ MenuId: 0, MenuName: 'CAT', SubMenuName: 'CAT-Exception', exceptionCode: code, page: 'CAT' });
  }
  getPreValidationCount(Label:any, Date:any) {
    this.Label = Label;
    this.isLoadingResults = true;
    this.SharedHttpClientService.get(
      this.UrlsService.setAPIURl1(
        APIURL.CAT_Dash_Pre_Validation,
        this.UserService.getActiveMPID() + "/" + Label + "/" + Date))
      .pipe(map((response: Response) => {
        this.isLoadingResults = false;
        return response;
      }))
      .subscribe({
        next: (Element: any) => {
          if (Element == null) {
          Element = [{ Reject_Code: "No Data", Rejects: "0", Exception_Description: "No Data" }];
          this.dataSource.data = Element
          } else {
            let dataArray:any=[];
            let labelArray:any=[];

          for (let i = 0; i < Element.length; i++) {
            // this.dataset.push({ Error_Code: Element[i].exception_Code, Errors: Element[i].count, Exception_Description: Element[i].exception_Description })
            this.totalExceptions = this.totalExceptions + Element[i].count;
            if (i < 5) {//inserted top 6 values only
              this.pieChartLabels[i]=(Element[i].exception_Code * 1);
              this.dataset[i]=({ Reject_Code: Element[i].exception_Code, Rejects: Element[i].count, Exception_Description: Element[i].exception_Description })
              this.pieChartData[i]=(Element[i].count);
              labelArray.push(this.pieChartLabels[i]);
              dataArray.push(this.pieChartData[i]);

              if (this.pieChartData)
                this.chartData= {
                  labels: labelArray,
                  datasets: [{data: dataArray,
                  backgroundColor: ['rgba(255,0,0,0.3)', 'rgba(0,255,0,0.3)', 'rgba(0,0,255,0.3)', 'rgba(0,245,255,10.3)', 'rgba(5,0,255,0.3)'],
                  }]
                }
            }
          }
          
        }
        //   Element.push({ count: "0", exception_Code: "0012", exception_Description: "CAT Exception" })
        this.dataSource.data = this.dataset;
        this.isLoadingResults = false;
        },
        error: (err: HttpErrorResponse) => {
          this.isLoadingResults = false;
          this.isRateLimitReached = true;
        }
      });  
  }

  Route(code: any) {
    this.redirectUrl = '/pages/CAT/CAT-Exception/' + this.LastCATExecutionDate + '/' + code;
  }
  ngOnDestroy() {
    if(this.subscription)
    this.subscription.unsubscribe();
  }
}
